<script setup>
import { computed } from 'vue'
import dayjs from 'dayjs'
import TvbPreferredSources from '@/components/TvbPreferredSources/index.vue'

const props = defineProps({
  size: { type: String, default: null },
  info: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const toDateTime = (time) => {
  if (time && dayjs(time).isValid()) {
    return dayjs.unix(time).format('YYYY-MM-DD HH:mm')
  } else {
    return ''
  }
}
const author = computed(() => props.info.author?.join('、'))
</script>

<template>
  <div class="tvb-article-subtitle" :class="size ? 'subtitle-' + size : ''">
    <div>
      <div v-if="info.author.length > 0" class="tvb-article-author">撰文：{{ author }}</div>
      <div v-if="info.publish_at && info.updated_at" class="tvb-article-date">
        <span class="tvb-article-date_publish"> 發佈日期：{{ toDateTime(info.publish_at) }} </span>
        <span
          v-if="info.updated_at && info.updated_at > info.publish_at"
          class="tvb-article-date_update"
        >
          更新日期：{{ toDateTime(info.updated_at) }}
        </span>
      </div>
    </div>
    <tvb-preferred-sources />
  </div>
</template>

<style lang="scss" scoped>
.tvb-article-subtitle {
  font-size: 16px;
  color: #888888;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap; // 允许按钮区域换行，避免内容溢出
  row-gap: 12px; // 换行后的行间距
  justify-content: space-between;
  align-items: center;

  &.subtitle-s,
  &.subtitle-xs {
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0px;
    margin-bottom: 12px;
    // 移动端纵向堆叠布局：按钮换行至信息下方并左对齐
    flex-direction: column;
    align-items: flex-start;
    row-gap: 10px; // 信息区与按钮间距
    .tvb-article-date_publish {
      margin-right: 8px;
    }
  }
}

.tvb-article-author {
  margin-bottom: 2px;
}

.tvb-article-date {
  display: flex;
  flex-wrap: wrap;
  .tvb-article-date_publish {
    margin-right: 12px;
  }
}
</style>
